import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function RecentDocuments(props: {
  setDebouncedQuery: (value: string) => void;
}) {
  const [query, setQuery] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      props.setDebouncedQuery(query.trim());
    }, 400); // debounce time

    return () => clearTimeout(handler);
  }, [query, props.setDebouncedQuery]);

  return (
    <Grid
      sx={{
        backgroundColor: "#FBE5C6",
        pl: "7%",
        pr: "7%",
        pb: "32px",
        mb: "36px",
        pt: "29px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Left: Title */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={{
              color: "#333333",
              textAlign: "left",
              fontFamily: "Poppins",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "15px",
              pt: "2px",
              pb: "2px",
            }}
          >
            Your
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              ml: "7px",
              pl: "5px",
              mt: "5px",
              mb: "5px",
              pt: "1px",
              pb: "2px",
              mr: "5px",
              backgroundColor: "#FBE5C6",
              borderRadius: "4px",
            }}
          >
            <Typography
              sx={{
                color: "#FF9A56",
                textAlign: "left",
                fontFamily: "Poppins",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "15px",
                pt: "2px",
                pb: "2px",
              }}
            >
              Recent
            </Typography>
            <ArrowDropDownIcon />
          </Box>

          <Typography
            sx={{
              color: "#333333",
              textAlign: "left",
              fontFamily: "Poppins",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "15px",
              pt: "2px",
              pb: "2px",
            }}
          >
            Documents
          </Typography>
        </Box>

        {/* Right: Search field */}
        <Box>
          <TextField
            variant="standard"
            size="small"
            placeholder="Search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
    </Grid>
  );
}
